/**
 * Copy to Clipboard Module
 * Kopiert den Wert aus data-copy in die Zwischenablage (z. B. IBAN im Spenden-Bereich)
 * und zeigt kurz ein Haekchen + "Kopiert" als Rueckmeldung.
 */

const FEEDBACK_DURATION = 2000;

async function copyText(text: string): Promise<boolean> {
  // Clipboard API (nur in sicherem Kontext: https / localhost)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* Fallback unten versuchen */
    }
  }

  // Fallback fuer aeltere Browser / http
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  textarea.remove();
  return ok;
}

export function initCopyToClipboard(): void {
  document.querySelectorAll<HTMLButtonElement>('.copy-btn[data-copy]').forEach(button => {
    const use = button.querySelector<SVGUseElement>('.copy-btn__icon use');
    const feedback = button.querySelector<HTMLElement>('.copy-btn__feedback');
    const iconHref = use?.getAttribute('href') ?? '';
    let resetTimeout: ReturnType<typeof setTimeout> | null = null;

    button.addEventListener('click', async () => {
      const ok = await copyText(button.dataset.copy ?? '');

      if (resetTimeout) clearTimeout(resetTimeout);
      button.classList.toggle('is-copied', ok);
      if (use && ok) use.setAttribute('href', iconHref.replace(/#copy$/, '#check'));
      if (feedback) feedback.textContent = ok ? 'Kopiert' : 'Kopieren nicht möglich';

      resetTimeout = setTimeout(() => {
        button.classList.remove('is-copied');
        if (use) use.setAttribute('href', iconHref);
        if (feedback) feedback.textContent = '';
      }, FEEDBACK_DURATION);
    });
  });
}
